import axios from '../utils/axios';

const SERVICE_URL = '/orders';

export const getOrdersList = async (
    searchTerm,
    page,
    rowsPerPage,
    LastEvaluatedKey
) => {
    try {
        let response = await axios.post(
            `${SERVICE_URL}`
            , 
            { 
                searchTerm,
                page,
                rowsPerPage,
                LastEvaluatedKey
            }
        );
        return response.data;
    } catch (error) {
        return {
            Items: [], 
            LastEvaluatedKey: {},
            totalPages: 1
        };
    }
}

export const orderUpdate = async (data) => {
    try {
        let response = await axios.put(`${SERVICE_URL}`, data);
        return response.data;
    } catch (error) {
        return {result: false, message: 'ocurrio un problema'};
    }
}

export const orderRetryShipment = async (_id) => {
    try {
        const response = await axios.put(`${SERVICE_URL}/retry-shipment`, { _id });
        return response.data;
    } catch (error) {
        return {
            result: false,
            message: error?.response?.data?.message || 'ocurrio un problema al reintentar la guia',
            order: error?.response?.data?.order || null,
            errorDetails: error?.response?.data?.errorDetails || null,
        };
    }
}

export const getCharacteristicsSearch = async (
    wordToSearch
) => {
    try {
        let response = await axios.post(`${SERVICE_URL}/search`, { wordToSearch });
        return response.data;
    } catch (error) {
        return {
            characteristics: [],
            error
        };
    }
}

export const getCharacteristicById = async (
    _id
) => {

    try {
        let response = await axios.post( `${SERVICE_URL}/id` , { _id } );
        return response.data;
    } catch (error) {
        return {
            error
        };
    }
}
